// AUTO-GENERATED by scripts/generate-products-catalog.js — do not edit.
// Source of truth: src/products/tags.json + public/images/products/

export const PRODUCTS_BASE_PATH = "/images/products";

export type ProductTag = "escolhe-bem-victory" | "healthy" | "plinko-pool" | "unhealthy";

export const ALL_PRODUCT_PATHS: readonly string[] = [
  "/images/products/agua-lima-limao.png",
  "/images/products/agua.png",
  "/images/products/areia-pet.png",
  "/images/products/atum-acores.png",
  "/images/products/atum.png",
  "/images/products/autocolantes.png",
  "/images/products/babete.png",
  "/images/products/barras-amendoim.png",
  "/images/products/barras-cruas-maca-canela.png",
  "/images/products/basmati.png",
  "/images/products/batata-frita.png",
  "/images/products/batatas-trufa.png",
  "/images/products/berrylicious.png",
  "/images/products/biglicious-chocolate-amendoim-caramelo.png",
  "/images/products/biglicious-oreo.png",
  "/images/products/biscoitos-manteiga-amendoa-choc.png",
  "/images/products/biscoitos-manteiga-amendoa.png",
  "/images/products/bolas-amendoa.png",
  "/images/products/bolas-avela.png",
  "/images/products/bolas-pistachio.png",
  "/images/products/bolo.png",
  "/images/products/bolsa.png",
  "/images/products/bone.png",
  "/images/products/chapeu-pet.png",
  "/images/products/chocolate-sal.png",
  "/images/products/chourico.png",
  "/images/products/chupa-chupa.png",
  "/images/products/colher.png",
  "/images/products/creme-marmelo.png",
  "/images/products/creme.png",
  "/images/products/crepes.png",
  "/images/products/detergente.png",
  "/images/products/donuts.png",
  "/images/products/energy-boost.png",
  "/images/products/flocos-de-aveia.png",
  "/images/products/fralda.png",
  "/images/products/garrafa.png",
  "/images/products/gelado.png",
  "/images/products/gomas-manga.png",
  "/images/products/gomas-morango-chocolate.png",
  "/images/products/gomas-morango.png",
  "/images/products/ice-tea-roma-hibiscus.png",
  "/images/products/immunity-boost.png",
  "/images/products/iogurte-morango.png",
  "/images/products/kombucha-ananas-pessego.png",
  "/images/products/kombucha-framboesa-gengibre.png",
  "/images/products/kombucha-framboesa.png",
  "/images/products/kombucha-maracuja.png",
  "/images/products/leite-magro.png",
  "/images/products/leite.png",
  "/images/products/leque.png",
  "/images/products/maca-cacau.jpg",
  "/images/products/mel.png",
  "/images/products/mini-bolachas-5-cereais.png",
  "/images/products/mini-bolachas-aveia-canela.png",
  "/images/products/mini-bolachas-chocolate.png",
  "/images/products/mix-sport.png",
  "/images/products/pate-cao.png",
  "/images/products/perfumador-roupa.png",
  "/images/products/petalas-caramelo-salgado.png",
  "/images/products/pipocas.png",
  "/images/products/pizza.png",
  "/images/products/refrigerante.png",
  "/images/products/saco.png",
  "/images/products/smoothie-acai.png",
  "/images/products/smoothie-imunidade.png",
  "/images/products/smoothie-maca-aveia-ameixa.png",
  "/images/products/smoothie-maca-manga-alperce.png",
  "/images/products/smoothie-pera-banana-coco.png",
  "/images/products/smoothie-tropical.png",
  "/images/products/sortido-fino-chocolate.png",
  "/images/products/super-breakfast-ameixa.png",
  "/images/products/super-breakfast-mirtilo.png",
  "/images/products/super-breakfast.png",
  "/images/products/superbreakfast.png",
  "/images/products/tente-outra-vez.png",
  "/images/products/tortitas.png",
  "/images/products/tropical-bliss.png",
];

export const PRODUCTS_BY_TAG: Record<ProductTag, readonly string[]> = {
  "escolhe-bem-victory": [
    "/images/products/agua-lima-limao.png",
    "/images/products/bolsa.png",
    "/images/products/bone.png",
    "/images/products/leque.png",
  ],
  "healthy": [
    "/images/products/agua-lima-limao.png",
    "/images/products/bolsa.png",
    "/images/products/bone.png",
    "/images/products/leque.png",
  ],
  "plinko-pool": [
    "/images/products/biscoitos-manteiga-amendoa-choc.png",
    "/images/products/biscoitos-manteiga-amendoa.png",
    "/images/products/mel.png",
    "/images/products/petalas-caramelo-salgado.png",
    "/images/products/sortido-fino-chocolate.png",
    "/images/products/tente-outra-vez.png",
  ],
  "unhealthy": [

  ],
};

export const TAGS_BY_PRODUCT: Record<string, readonly ProductTag[]> = {
  "/images/products/agua-lima-limao.png": ["healthy", "escolhe-bem-victory"],
  "/images/products/biscoitos-manteiga-amendoa-choc.png": ["plinko-pool"],
  "/images/products/biscoitos-manteiga-amendoa.png": ["plinko-pool"],
  "/images/products/bolsa.png": ["healthy", "escolhe-bem-victory"],
  "/images/products/bone.png": ["healthy", "escolhe-bem-victory"],
  "/images/products/leque.png": ["healthy", "escolhe-bem-victory"],
  "/images/products/mel.png": ["plinko-pool"],
  "/images/products/petalas-caramelo-salgado.png": ["plinko-pool"],
  "/images/products/sortido-fino-chocolate.png": ["plinko-pool"],
  "/images/products/tente-outra-vez.png": ["plinko-pool"],
};

export function byTag(tag: ProductTag): readonly string[] {
  return PRODUCTS_BY_TAG[tag] ?? [];
}

export function byTags(...tags: ProductTag[]): string[] {
  const seen: string[] = [];
  for (const tag of tags) {
    for (const p of byTag(tag)) {
      if (seen.indexOf(p) === -1) seen.push(p);
    }
  }
  return seen;
}

export function productFileName(productPath: string): string {
  return productPath.split("/").pop() ?? productPath;
}
